import repository from '@/repositories/repository'

export default baseUrl => {
    baseUrl = `${baseUrl}/ria-parametrizacao`

    return {
        index() {
            return repository.get(`${baseUrl}`)
        },
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        edit() {
            return repository.get(`${baseUrl}/edit`)
        },
        update(params) {
            return repository.put(`${baseUrl}`, params)
        },
        destroy() {
            return repository.delete(`${baseUrl}`)
        },
        download() {
            return repository.get(`${baseUrl}/download`, {responseType: 'arraybuffer'})
        },
    }
}